import noUiSlider from 'nouislider';
import sliderFactory from './slider.js';

const elements = '[data-slider]';

export default {
    init() {
        let Slider = sliderFactory(noUiSlider);

        $(elements).each((i, el) => {
            let slider = new Slider(el);

            try {
                slider.init();
            } catch(e) {
                /* ignore error if slider was already initialized*/
            }
        });


        $(document).on('enhance:ajaxload', () => {
            $(elements).each((i, el) => {
                let slider = new Slider(el);

                try {
                    slider.init();
                } catch(e) {
                    /* ignore error if slider was already initialized*/
                }
            });
        });
    }
};
